import {useLayoutEffect, useState} from "react";
import {getLocalItemAsJsonFromKey, setLocalItemFromKey} from "../../services/LocalStorage";
import {kSystemKeys} from "../../constants/keys";
import CoursesScreen from "../courses/CoursesScreen";
import {useResizeListener} from "../../listeners/SystemResizeListener";
import MetaExerciserScreen from "./exerciser/MetaExerciserScreen";
import {CoursesMetaStep} from "../../enums/CoursesMetaStep";
import {useAppLayoutStore} from "../../stores/appLayoutStore";

export default function MetaCoursesScreen() {
    // Used in Router to manage Flash user flow

    // PROPERTIES
    // ---- Navigation
    const [coursesRenderKey, setCoursesRenderKey] = useState(0);
    const setHideSidebar = useAppLayoutStore((state) => state.setHideSidebar);
    const [isLeaveModalOpen, setIsLeaveModalOpen] = useState(false)
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false)
    const [coursesMetaStep, setCoursesMetaStep] = useState(CoursesMetaStep.COURSES)

    // ---- Flash
    const [selectedGrade, setSelectedGrade] = useState(null)

    // ---- Exerciser
    const [levelAIdentifier, setLevelAIdentifier] = useState(null)
    const [exerciserProblem, setExerciserProblem] = useState(null)
    const [exerciserIndex, setExerciserIndex] = useState(0)
    const [isExerciserOver, setIsExerciserOver] = useState(false)

    // HOOKS
    // ---- Eventually close modal during screen resize
    useResizeListener(() => setIsLeaveModalOpen(false))

    // ---- Fires before repainting the screen : display or not app sidebar
    useLayoutEffect(() => {
        const isImmersive =
            coursesMetaStep === CoursesMetaStep.FLASH ||
            coursesMetaStep === CoursesMetaStep.EXERCISER;
        setHideSidebar(isImmersive);
        return () => setHideSidebar(false);
    }, [coursesMetaStep, setHideSidebar]);

    // BUILD
    switch (coursesMetaStep) {
        case CoursesMetaStep.COURSES:
            return <CoursesScreen key={coursesRenderKey}
                                  selectedGrade={selectedGrade}
                                  setFlashGrade={setFlashGrade} />
        case CoursesMetaStep.EXERCISER:
            return <MetaExerciserScreen isLeaveModalOpen={isLeaveModalOpen}
                                        setIsLeaveModalOpen={setIsLeaveModalOpen}
                                        onLeaveExerciserPressed={onLeavePressed}
                                        leaveSessionCallback={leaveSessionCallback}
                                        levelAIdentifier={levelAIdentifier}
                                        problem={exerciserProblem}
                                        currentIndex={exerciserIndex}
                                        setCurrentIndex={setExerciserIndex}
                                        isExerciserOver={isExerciserOver}
                                        setIsExerciserOver={setIsExerciserOver}
                                        isSnackbarOpen={isSnackbarOpen}
                                        handleClose={handleClose} />
        default:
            return <CoursesScreen selectedGrade={selectedGrade}
                                  setFlashGrade={setFlashGrade} />
    }

    // METHODS
    // ---- ---- ---- ----
    // NAVIGATION
    // ---- ---- ---- ----
    function handleClose(event, reason) {
        if (reason === 'clickaway') {
            return;
        }
        setIsSnackbarOpen(false);
    }

    // ---- Leave flash or exerciser session
    function leaveSessionCallback() {
        // LOCAL : Clear local storage
        localStorage.clear()
        // NAV : Reset state
        setCoursesRenderKey((k) => k + 1);
        resetState()
    }

    // ---- On leave flash pressed
    function onLeavePressed() {
        // if (metaStep >= 1) {
        if (coursesMetaStep !== CoursesMetaStep.COURSES) {
            // Case : flash/exerciser screen => ask for confirmation
            setIsLeaveModalOpen(true)
        } else {
            // Case : level or rules step screen => leave flash/exerciser session
            leaveSessionCallback()
        }
    }

    // ---- ---- ---- ----
    // FLASH
    // ---- ---- ---- ----
    // ---- LOGIC : Set flash level in state and local
    function setFlashGrade(selectedGrade) {
        // STATE : Set selected level
        setSelectedGrade(selectedGrade)
        // LOCAL STORAGE : Get local flash, update and set local flash
        const localSession = getLocalItemAsJsonFromKey(kSystemKeys.session)
        setLocalItemFromKey(kSystemKeys.session, {...localSession, grade: selectedGrade})
    }

    // ---- ---- ---- ----
    // EXERCISER
    // ---- ---- ---- ----
    // ---- CALLBACK : Fetch exerciser problem (after api call)
    // function fetchExerciserProblemCallback(levelAIdentifier, fetchedProblem) {
    //     // Defensive measure
    //     if (isNullOrUndefined(fetchedProblem))
    //         return
    //     // STATE : Set exerciser problem and meta step
    //     setLevelAIdentifier(levelAIdentifier)
    //     setExerciserProblem(fetchedProblem)
    //     const newMetaStep = CoursesMetaStep.EXERCISER
    //     setCoursesMetaStep(newMetaStep)
    //     // LOCAL STORAGE : Clear existing, and set new
    //     removeLocalItemFromKey(kSystemKeys.session)
    //     const localSession = getLocalItemAsJsonFromKey(kSystemKeys.session)
    //     setLocalItemFromKey(kSystemKeys.session, {...localSession, metaStep: newMetaStep, problem: fetchedProblem, levelAIdentifier: levelAIdentifier, currentQuestion: 0, isExerciserOver: false})
    //     // METRIC : To do
    // }

    // ---- STATE : reset state
    function resetState() {
        // ---- Navigation
        setIsLeaveModalOpen(false)
        setIsSnackbarOpen(false)
        setCoursesMetaStep(CoursesMetaStep.COURSES)
        // ---- Flash
        setSelectedGrade(null)
        // ---- Exerciser
        setLevelAIdentifier(null)
        setExerciserProblem(null)
        setExerciserIndex(0)
        setIsExerciserOver(false)
    }

}